import { Button, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { Box, Stack, useTheme } from "@mui/system";
import ModalComponent from "components/SharedComponents/Modal";
import { IDarkTheme } from "styles/darkTheme";
import styles from "./style";

import { IPlanItemProps } from ".";

interface IUpgradeModalProps {
  planItems: IPlanItemProps[];
  modalOpen: boolean;
  handleClose: () => void;
  isUpgrade: boolean;
  onSubmit: () => void;
  loading: boolean;
}
const UpgradeModal = ({
  planItems,
  modalOpen,
  handleClose,
  isUpgrade,
  onSubmit,
  loading
}: IUpgradeModalProps) => {
  const theme = useTheme<IDarkTheme>();
  const classes = styles();
  return (
    <ModalComponent
      closeStyles={{
        position: "absolute",
        right: "-0.75rem",
        top: "-0.75rem",
        fontSize: "2rem",
        background: theme.colors.semantic.semantic_white,
        borderRadius: "50%",
        padding: "0.25rem",
        color: "#969696",
        boxShadow: "0rem 0.25rem 1rem rgba(0, 0, 0, 0.1)"
      }}
      bodyStyles={{
        position: "relative",
        width: "31.75rem",
        height: "29.25rem"
      }}
      openModal={modalOpen}
      handleClose={handleClose}
    >
      <Stack direction="column" gap={2}>
        <Typography className={classes.headerTitle}>Plan Upgrade</Typography>
        {planItems?.map(({ icon, value, label }, index) => (
          <Stack
            direction="row"
            justifyContent="space-between"
            className={classes.planFlexContainer}
            sx={{
              backgroundColor: index % 2 === 0 ? "#F9F9FF" : ""
            }}
            key={value}
          >
            <Stack
              direction="row"
              gap={1}
              justifyContent="start"
              alignItems="center"
            >
              <Box
                component="img"
                width="1.5rem"
                height="1.5rem"
                alt="icon"
                src={icon}
              />
              <Typography className={classes.planLabel}>{label}</Typography>
            </Stack>
            <Typography className={classes.planValue}>{value}</Typography>
          </Stack>
        ))}
        <Stack
          direction="row"
          justifyContent="space-between"
          sx={{ marginTop: "1rem" }}
        >
          <Button
            onClick={handleClose}
            className={`${classes.cancelButton} ${classes.modalButton}`}
            variant="outlined"
          >
            Cancel
          </Button>
          <LoadingButton
            loading={loading}
            onClick={onSubmit}
            className={`${classes.submitButton} ${classes.modalButton}`}
            variant="contained"
          >
            {isUpgrade ? "Upgrade" : "Subscribe"}
          </LoadingButton>
        </Stack>
      </Stack>
    </ModalComponent>
  );
};

export default UpgradeModal;
